<script>
import EmailMarketingSlider from './../EmailMarketingSlider.svelte';
import { StoreForm } from './../register/steps/StoreForm.js';
import CurrencyFormatter from './../components/Elements/CurrencyFormatter.svelte';
import { PlansStore } from './Plans.store.js';
import { parseHtmlString } from "../libraries/parseHtmlString";
import { random_string } from '../libraries/random_string';
import { CartParserAddons } from '../register/steps/StoreCart';
import { SubscriptionsStore } from './SubscriptionsStore';
import { parse_membership_name } from 'tripod-styles/src/models/SubscriptionInterface';

export let tripod_plans;
export let interval;
export let affiliate = {};
export let user = {};
export let membership_selected;
export let onSelectPlan = function(){}; // for internal modules
let metadata = tripod_plans;
let showProducts = tripod_plans?.showProducts ?? true;
let currentPlan = tripod_plans?.currentPlan ?? false;
let lang = metadata.lang;

// this will work only in register widget.
let subscriptions = [];
if(($StoreForm?.dataForm?.subscriptions)){
    subscriptions = $StoreForm?.dataForm?.subscriptions ?? [];    
}

let email_marketing_purchased = false;

function EmailMarketingSliderUpdate({
    selected_addon,
    value,
    selected,
    list,
}){
    
    if(selected === value){
        email_marketing_purchased = true;
    }else{
        email_marketing_purchased = false;
    }
}

function SelectPlanInit(){
    let button = this;
    let plan_id = button.dataset.planId;
    let plan = parsedPlans.find(( plan )=>{
        if(plan.__id__ === plan_id){
            return plan;
        }
    })
    plan.membership_type = parse_membership_name(plan.membership_type);
    selectPlan(button, plan);
}

function selectPlan(target, plan){
    let email_marketing = document.querySelector(`.container-plan-${plan.__id__} .email-marketing-slider-module .input-range-selector`);
    plan.addons = {};
    if(email_marketing !== ""){
        try {
            plan.addons.email_marketing = JSON.parse(atob(email_marketing.value))
        } catch (error) {
            
        }
    }
    plan.addons = new CartParserAddons( plan.addons );
    let button = target;
    // will be executed outside any module
    tripod_plans.onSelect(plan, interval, plan.interval, button);

    // will be executed in internal modules
    
    onSelectPlan({
        plan: plan, interval: interval, button: button
    });
}

let parsedPlans = [];

let current_plan = null;


$: {
    if($PlansStore || $SubscriptionsStore.subscriptions){
        parsedPlans = $PlansStore.plans_views.filter(( plan )=>{
            let discountPlans = affiliate?.referralDiscounts?.plans ?? null;
            let interval_price;
            let percentOff = 0;
            plan.has_discount = "";
            plan.is_selected = false;
            plan.upgrades = [];
            plan.downgrades = [];
            $SubscriptionsStore.subscriptions.map(( subscription )=>{                
                let metadata = subscription.metadata;
                let items = subscription.items.data;
                items.map(( item )=>{
                    let subscription_plan = item.plan;
                    let id = item.id_plan;
                    if(plan.__id__ === id && metadata.membership_type === membership_selected){
                        let addons = metadata?.addons ?? null;
                        if(addons !== null){
                            addons = JSON.parse(addons);
                            plan.active_addons = addons;
                        }


                        plan.is_selected = true;
                        plan.interval = subscription_plan.interval;
                        plan.status = subscription.status;
                        current_plan = plan;
                        plan.subscription = subscription;

                    }
                    if(metadata.membership_type === membership_selected){
                        plan.subscription = subscription;
                    }
                })

                

            })


            if(interval !== "month"){
                if(typeof plan[`interval_${interval}_price`] === "undefined" || plan[`interval_${interval}_price`] === ""){
                    interval_price = plan.price_plan;
                    percentOff = 0;
                }else{
                    interval_price = plan[`interval_${interval}_price`];
                    percentOff = (plan.price_plan*100)/plan[`interval_${interval}_price`]-100;
                    percentOff = isNaN(percentOff) === false ? percentOff : 0;
                    percentOff = Number.parseInt(percentOff);
                    plan.has_discount = "has_discount";
                }
            }else{
                interval_price = plan.price_plan;
                percentOff = 0;
            }
            function onDicountsPlan(discountPlan){
                if(discountPlan.plan === plan.__id__){
                    plan.interval_current_price = interval_price;            
                    interval_price = interval_price - ((discountPlan.discountPercent/100)*interval_price);
                    plan.interval_discount = plan.interval_current_price - interval_price;
                    plan.hasReferralDiscounts = discountPlan.discountPercent;
                    plan.has_discount = "has_discount";
                }
            }
            plan.interval_selected = interval;
            // in case of discounts by referrals
            if(discountPlans  !== null){
                Object.values(discountPlans).map(( dp )=>{
                    onDicountsPlan(dp);
                })
            }else{
                // in case of discounts by tag
                if((plan.discountsPlan ?? null) !== null){
                    onDicountsPlan(plan.discountsPlan);
                }
            }
            


            

            interval_price = Number.parseFloat(Number.parseFloat(interval_price).toFixed(2))
            plan.interval_price = interval_price;
            plan.percentOff = percentOff;

            let currency = plan.currency ?? null !== null ? plan.currency : tripod_plans.currency;
            let is_recommended = ((plan.is_recommended ?? "Default") === "Recomendado") ? "recommended" : plan.is_recommended||"";
            let yearly = typeof plan.interval_year_price === "undefined" ? null : plan.interval_year_price;
            plan.currency = currency;
            plan.is_recommended = is_recommended;
            plan.yearly = is_recommended;
            plan.is_available = plan.is_available || "public";

            plan.active = false;


            let same_interval = (plan?.interval ?? null) === interval;
            if(plan.is_selected){
                plan.active = true;
                email_marketing_purchased = true;
                if(!same_interval){
                    plan.active = false;
                }
            }
            

            if(plan.status === "canceled"){
                plan.active = false;
            }
            


            currentPlan.__id__ !== plan.__id__ && plan.is_selected === false && ((plan?.interval ?? null) === interval) === false

            let tag = user?.userFromCampaign ?? "";

            if(plan.is_available === "public" || tag === (plan?.tag || null)){
                return plan;
            }
        })
        
        /*parsedPlans = parsedPlans.filter(( plan )=>{
            plan.upgrades = [];

            
            let parse = function(n){
                return Number.parseFloat((Number.parseFloat(n)).toFixed(2));
            }
            let parsePrice = function(n, discountPercent){
                let origin = parse(n);
                if(discountPercent > 0){
                    n = (origin-(origin*(discountPercent/100)))
                }
                return n;
            }


            if(current_plan === null){
                parsedPlans.map(( item )=>{
                    let discountItem = item?.discountPercent ?? 0;
                    let month_price = parsePrice(item.price_plan, discountItem);
                    let year_price = parsePrice(parse(item.interval_year_price)*12, discountItem);
                    plan.upgrades.push( {
                        id: item.__id__,
                        prices: {
                            real_year_price: year_price,
                            real_month_price: month_price,
                            year: year_price,
                            month: month_price
                        }
                    })

                    plan.downgrades.push( {
                        id: item.__id__,
                        prices: {
                            real_year_price: year_price,
                            real_month_price: month_price,
                            year: 0,
                            month: 0
                        }
                    } )
                });
                return plan;
            }
            
            
            let current_subscription = current_plan.subscription;
            let current_invoices = current_subscription?.invoices.data[0] ?? {};            
            let last_amount = current_invoices?.amount_paid ?? 0;

            let lines = current_invoices?.lines?.data ?? [];
            
            let amounts_lines = 0;
            lines.map((line)=>{
                if(line.amount < 0){
                    amounts_lines = amounts_lines + Math.abs(line.amount)
                    last_amount = Math.abs(amounts_lines + last_amount);
                }
            })
            last_amount = last_amount/100;
            plan.last_amount = last_amount;
            plan.current_invoices = current_invoices;

           
            
            let today = Number.parseInt(new Date().getTime()/1000);
            let days_in_month = plan.subscription.calc_period.days_in_month
            let period_start = current_plan.subscription.current_period_start;
            let period_ends = current_plan.subscription.current_period_end;
            let total_days = (period_ends - period_start) / (3600*24);
            let days_left =  period_ends - today;
            days_left =  parse( (days_left / (3600*24)) );

            
            
            
            
            if(total_days < 30){
                days_left = (days_left * 30) / days_in_month
            }

            let current_interval = current_plan.interval;
            
           
            

            parsedPlans.map(( item )=>{
                let discountItem = item?.discountPercent ?? 0;
                let month_price = parsePrice(item.price_plan, discountItem);
                let year_price = parsePrice(parse(item.interval_year_price)*12, discountItem);
                plan.current_interval = current_interval;
                let days = 30;
                if(current_interval === "year"){
                    days = 365;
                }

                
                let type = "upgrade";
                if(month_price > last_amount){
                    type = "upgrade";
                }else{
                    type = "downgrade";
                }
                
                plan.upgrades.push( {
                    id: item.__id__,
                    prices: {
                        real_year_price: year_price,
                        real_month_price: month_price,
                        year: parse( (year_price-((days_left*last_amount)/days)) ),
                        month: parse( (month_price-((days_left*last_amount)/days)) )
                    }
                })

                plan.downgrades.push( {
                    id: item.__id__,
                    prices: {
                        real_year_price: year_price,
                        real_month_price: month_price,
                        year: 0,
                        month: 0
                    }
                } )
            })

            return plan;
        })*/

    }
}


</script>
{#if $PlansStore.plans_views.length <= 0}
    <h2 class="font-size-20 has-text-centered has-text-dark">
        Cargando planes...
    </h2>
{/if}
{#each parsedPlans as plan}
    {#if plan.type === "PLAN"}
        <div class="column column-card-plan container-plan-{plan.__id__}">
            <section class="{plan.is_recommended} is-plan">
                <div class="container-discount">
                    {#if typeof plan?.hasReferralDiscounts === "undefined"}
                        {#if Number.isInteger(plan.percentOff)}
                            {#if plan.percentOff > 0}
                                <p class="has-text-left">
                                    <span class="tag is-small percent-off-tag tag-percent fw400 is-rounded {plan.is_recommended} tag-percent-off">
                                        Ahorra {plan.percentOff}%
                                    </span>
                                </p>
                            {/if}
                        {/if}
                        {:else}
                            <p class="has-text-left">
                                <span class="tag is-small percent-off-tag tag-percent fw400 is-rounded {plan.is_recommended} tag-percent-off">
                                    Ahorra {plan.hasReferralDiscounts}%
                                </span>
                            </p>
                    {/if}
                </div>
                <header class="is-flex">
                    {#if plan.is_recommended === "Recomendado" || plan.is_recommended === "recommended"}
                        <h4 class="defaultItem {plan.has_discount}  has-text-centered">
                            {metadata.lang.defaultItem}
                        </h4>
                    {/if}
                    <div>                    
                        <h2 class="is-size-4 has-text-weight-bold is-flex Title-Plan-{plan.is_recommended}">
                            <span>
                                <span class="{plan.img_plan} plan-icons-container"><span class="path1"></span><span class="path2"></span></span>
                            </span>
                            <span class="name_plan-span">
                                {plan.name_plan}
                            </span>
                        </h2>
                        {#if typeof plan.hasReferralDiscounts !== "undefined"}
                            <p class="has-text-centered is-size-4 has-text-weight-semibold price-element-container dontpay-price">
                                <span class="price-element">
                                    <span class="is-size-7 has-text-weight-light currency-symbol">
                                        {plan.currency[0]}
                                    </span>
                                    <span style="text-decoration: line-through;">
                                        <CurrencyFormatter parseCents={true} number={plan.interval_current_price} />
                                    </span>
                                </span>
                                <span class="is-size-7 has-text-weight-light currency-code">
                                    {plan.currency[1]}
                                </span><span class="is-size-7 has-text-weight-semibold"> / 
                                    {metadata.lang.eachMonth}
                                </span>
                            </p>
                        {/if}
                        <p class="has-text-centered is-size-3 has-text-weight-semibold price-element-container main-price {plan.is_recommended}">
                            <span class="price-element">
                                <span class="is-size-6 has-text-weight-light currency-symbol">
                                    {plan.currency[0]}
                                </span>
                                <CurrencyFormatter parseCents={true} number={plan.interval_price} />
                            </span>
                            <span class="is-size-7 has-text-weight-light currency-code">
                                {plan.currency[1]}
                            </span><span class="is-size-7 has-text-weight-semibold"> / 
                                {metadata.lang.eachMonth}
                            </span>
                        </p>
                        {#if plan.yearly !== null && interval === "year"}
                            {#if plan[`interval_${interval}_price`] ?? "" !== ""}
                                <p class="has-text-centered is-size-7">
                                    {plan.currency[0]}<span>
                                        {#if interval === "year"}
                                            <CurrencyFormatter parseCents={true} number={plan.interval_price*12} />
                                        {/if}
                                    </span> 
                                    {plan.currency[1]} / 
                                    <span class="is-lowercase">
                                        {metadata.lang.year}
                                    </span>
                                </p>
                            {/if}
                            
                        {/if}                    
                    </div>
                </header>
                <main>
                    <ul class="container-items">
                        {#each Object.values(JSON.parse(plan.items)) as item}
                            <li class="item-list">
                                <span class="icon">
                                    <i class="fas fa-check"></i>
                                </span>
                                <span class="content-item">
                                    {@html parseHtmlString(item)}
                                </span>
                            </li>
                        {/each}
                    </ul>
                </main>
                <footer>
                    {#if plan.membership_type === "funnels"}
                        {#if (lang?.slider?.benefits||null) !== null}
                                <div class="columns is-multiline">
                                    <div class="column email-marketing-slider-module {plan.__id__}">
                                        <EmailMarketingSlider interval={interval} onUpdate={EmailMarketingSliderUpdate} current={(plan?.active_addons?.email_marketing?.limit ?? 1)} version={plan.is_recommended.toLowerCase()} id={"slider-"+random_string(3)} lang={lang.slider} />
                                    </div>
                                </div>
                            {/if}
                        {/if}
                    {#if (plan.active === false) }
                        <div class="buttons is-grouped is-centered button-container-select">
                            <button
                                on:click="{SelectPlanInit}"
                                data-plan-id="{plan.__id__}" 
                                data-price-on-year-monthly="{plan.price_on_year_monthly}"
                                data-position-plan="{plan.position_plan}"
                                data-type="{plan.type}"
                                data-membership-type="{parse_membership_name(plan.membership_type)}"
                                data-interval="{interval}"
                                type="button" class="button is-success button-select-plan is-rounded fw400 has-text-white button-success-3pod">
                                <span class="is-capitalized">
                                    {lang.setPlan}
                                </span>
                            </button>
                        </div>
                        {:else}
                            {#if email_marketing_purchased === true}
                                    <div class="buttons is-grouped is-centered button-container-select">
                                        <button 
                                            type="button" class="button is-primary is outlined-white is-rounded fw400 has-text-white button-primary-3pod outlined-white" disabled>
                                            <span class="is-capitalized">
                                                {lang.currentPlan}
                                            </span>
                                        </button>
                                    </div>
                                {:else}
                                <div class="buttons is-grouped is-centered button-container-select">
                                    <button 
                                        on:click="{SelectPlanInit}"
                                        data-plan-id="{plan.__id__}" 
                                        data-type="{plan.type}"
                                        data-membership-type="{plan.membership_type}"
                                        data-interval="{interval}"
                                        type="button" class="button is-primary button-select-plan is outlined-white is-rounded fw400 has-text-white button-primary-3pod outlined-white">
                                        <span class="is-capitalized">
                                            {lang.updatePlan ?? lang.setPlan}
                                        </span>
                                    </button>
                                </div>
                            {/if}
                    {/if}
                </footer>
            </section>
        </div>
    {/if}    
{/each}
{#if showProducts === true}
    <div class="column is-12">
        <hr>
    </div>
    {#each parsedPlans as plan}
        {#if plan.type === "PRODUCT"}
            <div class="column is-12">
                <div class="box">
                    <section class="is-product columns is-multiline">
                        <header class="column is-4">
                            <div class="container-discount">
                                {#if typeof plan?.hasReferralDiscounts === "undefined"}
                                    {#if Number.isInteger(plan.percentOff)}
                                        {#if plan.percentOff > 0}
                                            <p class="has-text-left">
                                                <span class="tag is-small percent-off-tag tag-percent fw400 is-rounded {plan.is_recommended} tag-percent-off">
                                                    Ahorra {plan.percentOff}%
                                                </span>
                                            </p>
                                        {/if}
                                    {/if}
                                    {:else}
                                        <p class="has-text-left">
                                            <span class="tag is-small percent-off-tag tag-percent fw400 is-rounded {plan.is_recommended} tag-percent-off">
                                                Ahorra {plan.hasReferralDiscounts}%
                                            </span>
                                        </p>
                                {/if}
                            </div>
                            <h2 class="is-size-4 has-text-weight-bold is-flex Title-Plan-{plan.is_recommended}">
                                <span>
                                    <span class="{plan.img_plan} plan-icons-container"><span class="path1"></span><span class="path2"></span></span>
                                </span>
                                <span class="name_plan-span">
                                    {plan.name_plan}
                                </span>
                            </h2>
                            {#if typeof plan.hasReferralDiscounts !== "undefined"}
                            <p class="has-text-centered is-size-4 has-text-weight-semibold price-element-container-product dontpay-price">
                                    <span class="price-element price-element-product">
                                    <span class="is-size-7 has-text-weight-light currency-symbol">
                                        {plan.currency[0]}
                                    </span>
                                    <span style="text-decoration: line-through;">
                                        <CurrencyFormatter parseCents={true} number={plan.interval_current_price} />
                                    </span>
                                </span>
                                <span class="is-size-7 has-text-weight-light currency-code">
                                    {plan.currency[1]}
                                </span><span class="is-size-7 has-text-weight-semibold"> / 
                                    {metadata.lang.eachMonth}
                                </span>
                            </p>
                            {/if}
                            <p class="is-block is-size-3 has-text-weight-semibold price-element-container-product main-price {plan.is_recommended}">
                                <span class="price-element price-element-product">
                                    <span class="is-size-6 has-text-weight-light currency-symbol">
                                        {plan.currency[0]}
                                    </span>
                                    <CurrencyFormatter parseCents={true} number={plan.interval_price} />
                                </span>
                                <span class="is-size-7 has-text-weight-light currency-code">
                                    {plan.currency[1]}
                                </span><span class="is-size-7 has-text-weight-semibold"> / 
                                    {metadata.lang.eachMonth}
                                </span>
                            </p>
                        </header>
                        <main class="column is-8">
                            <ul class="container-items-product">
                                {#each Object.values(JSON.parse(plan.items)) as item}
                                    <li class="item-list item-list-product">
                                        <span class="icon">
                                            <i class="fas fa-check"></i>
                                        </span>
                                        <span class="content-item">
                                            {@html parseHtmlString(item)}
                                        </span>
                                    </li>
                                {/each}
                            </ul>                            
                        </main>                                           
                    </section>
                    <div>
                        <div class="buttons is-flex is-grouped button-container-select-product">
                            <button 
                                on:click="{SelectPlanInit}"
                                data-plan-id="{plan.__id__}" 
                                data-price-on-year-monthly="{plan.price_on_year_monthly}"
                                data-position-plan="{plan.position_plan}"
                                data-type="{plan.type}"
                                data-membership-type="{parse_membership_name(plan.membership_type)}"
                                data-interval="{interval}"
                                type="button" class="button is-success button-select-plan is-rounded fw400 has-text-white button-success-3pod">
                                <span class="is-capitalized">
                                    {lang.setProduct}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
    {/each}
{/if}

<style>

:global(.section) .Title-Plan-Default, :global(.section) .Title-Plan-Default .name_plan-span{
    color: var(--color-dark-grey);
}
:global(.section) .Title-Plan-recommended, :global(.section) .Title-Plan-recommended .name_plan-span{
    color: #fff;
}
header{
    justify-content: center;
    position: relative;
}
section.is-plan{
    color: var(--color-dark-grey);
    padding: 2.5rem 2rem;
    padding-top: 4rem;
    overflow: clip;
    position: relative;
    height: 100%;
    max-width: 425px;
    padding-bottom: 2rem;
    margin: auto;
}
section.is-product{
    margin-top: 1.25rem;
}
@media only screen and (max-width:1023px){
    section.is-product{
        display: grid;
        justify-items: center;
    }
}
.email-marketing-slider-module{
    margin-bottom: 1.75rem;
}
@media only screen and (max-width: 1268px){
    .email-marketing-slider-module{
        margin-bottom: 2.75rem;
    }
}
@media only screen and (max-width: 425px){
    .email-marketing-slider-module{
        margin-bottom: 3.75rem;
    }
}
section:global(.recommended){
    background: transparent linear-gradient(180deg, #344fff 0%, #09E2FF 100%) 0% 0% no-repeat padding-box;
    border-radius: 20px;
    transform: scale(1.06);
}
section:global(.recommended) header{
    color: #fff;
}
.main-price, .dontpay-price{
    position: relative;
    margin-bottom: 0;
}
.currency-symbol{
    position: relative;
    bottom: 12px;
}
.item-list{
    font-size: 0.85rem;
    padding: 0.25rem;
}
section:global(.recommended .item-list){
    color: #fff;
}
.item-list .icon{
    width: 9px;
    height: 9px;
    padding: 9px;
    font-size: 9px;
    border-radius: 40px;
    background: var(--color-primary);
    color: #fff;
}
section:global(.recommended .item-list .icon){
    background: var(--color-yellow);
    color: var(--color-dark-grey);
}
.text-on-current{
    color: #424B54;
}
section:global(.recommended .text-on-current){
    color: #fff;
}

.container-items{
    padding: 1.25rem 1rem;
}
.container-items-product{
    padding: 0.25rem 2rem;
}
.content-item{
    margin-left: 12px;
}
.item-list-product {
    display: inline-flex;
    width: 320px;
}
.defaultItem{
    position: absolute;
    transform: rotate(45deg);
    padding: 0 4rem !important;
    background: var(--color-yellow);
    color: var(--color-dark-grey);
    font-size: 14px !important;
    font-weight: 600 !important;
}
.defaultItem:global(.has_discount){
    top: -70px;
    right: -89px;
}
.defaultItem:not(.has_discount){
    top: -40px;
    right: -89px;
}
footer{
    padding: 0 !important;
    padding-top: 2rem !important;    
}
.button-container-select{
    left: 0;
    margin: auto;
    position: absolute;
    width: 100%;
    bottom: 1rem;
}
.button-container-select button{
    padding: 24px 22px;
}
.button-container-select-product{
    margin: 1.25rem auto;
}
.button-container-select-product{
    justify-content: right;
    margin-right: 4rem;
}
@media only screen and (max-width:1023px){
    .button-container-select-product{
        justify-content: center;
        margin-right: 0rem;
    }
}
.plan-icons-container{
    font-size: 3rem;
    margin-right: 1.25rem;
}
.plan-icons-container .path1:before, .plan-icons-container .path2:before{
    color: var(--color-primary);
}
.recommended .plan-icons-container .path1:before, .recommended .plan-icons-container .path2:before{
    color: #fff
}
.recommended .content-item :global(strong){
    color: #fff
}
.content-item :global(strong){
    color: var(--color-primary);
}
.column-card-plan{
    min-width: 340px;
}
.special-discount-from-referral{
    background: var(--color-purple) !important;
    color:#fff !important;
}
.main-price.recommended .price-element{
    color: var(--color-yellow);
    
}
.price-element, .price-element-container{
    display: flex;
    align-items: baseline;
}
.price-element-container{
    justify-content: center;
}
.price-element-container-product{
    margin-left: 4.25rem;
    color: var(--color-dark-grey);
}
.price-element-product{
    display: inline-flex;
}
.tag-percent-off{
    color: var(--color-dark-grey);
    background-color: rgb(252 253 255 / 25%);
    color:#fff;
    font-size: 11px;
}
.percent-off-tag:not(.recommended){
    background: #f3f5ff;
    color: var(--color-black-bis);
}
.tag-percent{
    padding: 10px 12px;
}
.container-discount p{
    margin-bottom: 1rem;
    margin-left: 0.75rem;
}
</style>